import type { PageResponse } from '@/types/api';

/** Fetch all pages for HR calendar views (month-scoped server filters). */
export async function fetchAllHrPages<T>(
  fetchPage: (page: number) => Promise<PageResponse<T>>,
  maxPages = 50,
): Promise<T[]> {
  const all: T[] = [];
  for (let page = 0; page < maxPages; page += 1) {
    const res = await fetchPage(page);
    all.push(...res.content);
    const isLast = res.last ?? page >= res.totalPages - 1;
    if (isLast || res.content.length === 0) {
      break;
    }
  }
  return all;
}
